export default "__VITE_ASSET__CvLun$9O__"